import { render, staticRenderFns } from "./UploadButton.vue?vue&type=template&id=55926c94&scoped=true&"
import script from "./UploadButton.vue?vue&type=script&lang=ts&"
export * from "./UploadButton.vue?vue&type=script&lang=ts&"
import style0 from "./UploadButton.vue?vue&type=style&index=0&id=55926c94&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55926c94",
  null
  
)

export default component.exports